import React from 'react';
import DefaultMsgPage from '../../components/DefaultMsgPage';
import { MessageProps } from './types';

const Message: React.FC<MessageProps> = ({
  traductionKey,
  traductionContentParams,
  image,
  primaryLink,
  secondaryLink,
}) => {
  const onPrimary = () => window.location.href = primaryLink || '';
  const onSecondary = secondaryLink ? () => window.location.href = secondaryLink : undefined;
  return (
    <div className="main-portal">
      <DefaultMsgPage
        traductionKey={traductionKey}
        traductionContentParams={traductionContentParams}
        image={image}
        onPrimary={onPrimary}
        onSecondary={onSecondary}
      />
    </div>
  );
};

Message.defaultProps = {
  traductionKey: 'generic_error_screen',
  image: 'brokenSuitcase',
  primaryLink: '/login?prompt=login',
  secondaryLink: undefined
};

export default Message;
